/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import Markdown from 'markdown-to-jsx';
import UList from './ulist';
var AISummaryCSSStyles = css({
  font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  wordWrap: 'break-word',
  wordBreak: 'break-word',
  whiteSpace: 'normal',
  WebkitUserSelect: 'text',
  MozUserSelect: 'text',
  MsUserSelect: 'text',
  userSelect: 'text'
});

/**
 * Move this type to the index file upon FF cleanup. bandicoots-compiled-migration-smartcard
 * Remove the export as well.
 */

/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */

var AISummaryOld = function AISummaryOld(_ref) {
  var _ref$content = _ref.content,
    content = _ref$content === void 0 ? '' : _ref$content,
    overrideCss = _ref.overrideCss,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'ai-summary' : _ref$testId,
    _ref$minHeight = _ref.minHeight,
    minHeight = _ref$minHeight === void 0 ? 0 : _ref$minHeight;
  if (!content && minHeight === 0) {
    return null;
  }
  return jsx(Markdown, {
    "data-testid": testId,
    css: [AISummaryCSSStyles, overrideCss],
    children: content,
    options: {
      forceWrapper: true,
      overrides: {
        ul: UList
      }
    },
    style: {
      minHeight: minHeight
    }
  });
};
export default AISummaryOld;